import React, { useEffect, useState } from "react"
import { FormControl } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import CurrencyInputWrapper from "./CurrencyInputWrapper"
import classes from "./CurrencyInputComponent.module.scss"

const CurrencyInputComponent = props => {
  const {
    value,
    onChange = () => { },
    error,
    label,
    onFocus = () => { },
    onBlur = () => { },
    disabled = false,
    className,
    readOnly
  } = props

  const i18n = useTranslation()[1]

  const [movePlaceholder, setMovePlaceholder] = useState(false)

  const handleFocus = (e) => {
    onFocus(e)

    setMovePlaceholder(true)
  }

  const handleBlur = (e) => {
    onBlur(e)

    !isNaN(value) ?
      setMovePlaceholder(true) :
      setMovePlaceholder(false)
  }

  const handleValueChange = (value, name, values) => {
    onChange(values.float)
  }

  useEffect(() => {
    if (!isNaN(value)) setMovePlaceholder(true)
  }, [value])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={className}>
      <div className={classes["input"]}>
        {
          !!label &&
          <label
            className={clsx(
              classes["placeholder"],
              isLtr && classes["placeholder-ltr"],
              movePlaceholder && classes["move"]
            )}
          >
            {label}
          </label>
        }
        <CurrencyInputWrapper
          readOnly={readOnly}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={disabled}
          value={value}
          customInput={FormControl}
          allowDecimals={false}
          onValueChange={handleValueChange}
          className={clsx(
            !!error && classes["input-error"],
            readOnly && classes["read-only"]
          )}
        />
      </div>
      {
        !!error &&
        <div className={classes["error"]}>
          {error}
        </div>
      }
    </div>
  )
}

export default CurrencyInputComponent